import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getExtractionDataIcon } from '~/common/componentMapper/QuestionExtraction/handlers';

import { StyledExtractionDataIconPseudoButton } from '../styledComponents/styledButtons';
import { ARIA_LABELS } from './constants';

type InlineExtractionIconProps = {
  iconType?: number;
  isInline?: boolean;
  padding?: string;
  margin?: string;
  testId?: string;
  questionName?: string;
};

export default function InlineExtractionIcon({
  iconType,
  isInline = true,
  padding = '0 0.25rem',
  testId = '',
  margin = '0',
  questionName = '',
}: Readonly<InlineExtractionIconProps>) {
  const icon = getExtractionDataIcon(iconType);
  if (!icon) {
    return null;
  }

  const ariaLabel = ARIA_LABELS[iconType];
  const isImgSrc = typeof icon === 'string';
  const inlineIcon = isImgSrc ? (
    <img src={icon} aria-label={ariaLabel} />
  ) : (
    <FontAwesomeIcon icon={icon} aria-label={ariaLabel} />
  );

  return (
    <StyledExtractionDataIconPseudoButton
      data-testid={`${questionName}-inline-extraction-icon`}
      padding={isImgSrc ? 'unset' : padding}
      isInline={isInline}
      margin={margin}
      data-testId={testId}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      {inlineIcon}
    </StyledExtractionDataIconPseudoButton>
  );
}
